// extracted by mini-css-extract-plugin
export var button = "styles-module--button--59d38";
export var container = "styles-module--container--09bbc";
export var desktop = "1340px";
export var disabled = "styles-module--disabled--4d1a4";
export var giant = "2200px";
export var icon = "styles-module--icon--a3d33";
export var inactive = "styles-module--inactive--9642d";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";